import { Route, Routes } from 'react-router-dom';
import List from './List';

const BangKeHoaDonChietKhau = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
    </Routes>
  )
}

export default BangKeHoaDonChietKhau